import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type AzWarningBannerVariant = 'warning' | 'info';

@Component({
  selector: 'app-az-warning-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './az-warning-banner.component.html',
  styleUrl: './az-warning-banner.component.scss',
})
export class AzWarningBannerComponent {
  @Input() testId = '';
  @Input() variant: AzWarningBannerVariant = 'warning';

  get icon(): string {
    return this.variant === 'info' ? 'info' : 'warning';
  }
}
